<h1 class="widget-title">{{ title() }}</h1>

@if (canAdd()) {
  <xui-mat-autocomplete
    placeholder="Search Diagnosis Codes"
    [searchObservable]="searchFn()"
    [displayResultsCardTemplate]="displayResultsCardTemplate"
    [disabled]="isProcessing()">
  </xui-mat-autocomplete>
}

<ng-template #displayResultsCardTemplate let-result="result" let-queryText="queryText">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <div class="flex-grow-1">
      <span class="fw-bold" [innerHtml]="result.code | textHighlight: queryText"></span>
      <span class="ms-2" [innerHtml]="result.description | textHighlight: queryText"></span>
    </div>
    <button mat-icon-button (click)="onItemSelected(result)" [disabled]="isProcessing()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <mat-form-field color="primary" appearance="fill" class="compact w-100" subscriptSizing="dynamic">
    <mat-label>Comments/Notes</mat-label>
    <input matInput type="text" [ngModel]="getResultComment(result.id)" (ngModelChange)="setResultComment(result.id, $event)"/>
  </mat-form-field>
</ng-template>

@if (isProcessing()) {
  <xui-loading-spinner></xui-loading-spinner>
}

<div class="mat-card-list">
  @for (item of items(); track item.id; let i = $index) {
    <mat-card class="compact" [class.referred]="isReferred(item)">
      <mat-card-content>
        <mat-card-title class="d-flex justify-content-between align-items-start mat-bold" [class.primary]="usePrimaryText()">
          {{ item.code }} {{ item.description }}
          @if (canDelete()) {
            <button
              class="mat-card-button-top-right-corner"
              mat-icon-button
              [disabled]="isProcessing()"
              (click)="onRemoveItem(item, i)">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </mat-card-title>
        @if (isReferred(item)) {
          <div class="referral-indicator">
            <mat-icon>send</mat-icon>
            <span>{{ getReferralText(item) }}</span>
          </div>
        }
        @if (item.comment) {
          <span class="item-comment">{{ item.comment }}</span>
        }
        <mat-card-subtitle class="d-flex justify-content-between">
          <span>{{ item.modifiedDateUtc | practiceDateTime:'yyyy-MM-dd HH:mm' }}</span>
          @if (item.lastModifiedUser) {
            <span>{{ item.lastModifiedUser.firstName }} {{ item.lastModifiedUser.surname }}</span>
          }
        </mat-card-subtitle>
      </mat-card-content>
      <mat-divider></mat-divider>
    </mat-card>
  }

  @if (!hasItems()) {
    <mat-card>
      <mat-card-content>
        <span>No diagnosis codes have been added.</span>
      </mat-card-content>
    </mat-card>
  }
</div>

<div class="widget-footer">
  <ng-content select="[widget-footer]"></ng-content>
</div>
